import {
  getNextPageParam,
  keepPreviousData,
  type Page,
  useInfiniteQuery,
  useQuery,
} from '@fv/client-core'
import type { ProvisionFilterBase, ProvisioningEntry } from '@fv/client-types'
import type { CarrierProvisioningConfiguration } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

import type { ProvisionerAccountProvisioningDto } from './dto'

export const provisionerQueryKeys = {
  all: ['provisioning'],
  config: () => [...provisionerQueryKeys.all, 'config'],
  filtered: (filter: ProvisionFilterBase) => [
    ...provisionerQueryKeys.all,
    filter.status,
    filter.sort,
    filter.sortDir,
    ...(filter.search ? [filter.search] : []),
  ],
  account: (accountId?: string) => [
    ...provisionerQueryKeys.all,
    'account',
    accountId,
  ],
}

export const useProvisionerList = (filter: ProvisionFilterBase) => {
  return useInfiniteQuery({
    queryKey: provisionerQueryKeys.filtered(filter),
    queryFn: ({ pageParam }) =>
      shipperFetch<Page<ProvisioningEntry>>(`/provisioner`, {
        query: {
          ...filter,
          limit: 50,
          skip: pageParam,
        },
      }),
    initialPageParam: 0,
    getNextPageParam,
    placeholderData: keepPreviousData,
  })
}

export const useProvisionerAccountDetails = (accountId?: string) => {
  return useQuery(
    provisionerQueryKeys.account(accountId),
    () =>
      shipperFetch<ProvisionerAccountProvisioningDto>(
        `/provisioner/account/${accountId}`,
      ),
    {
      enabled: !!accountId,
    },
  )
}

export const useProvisionerCarrierConfig = () => {
  return useQuery(
    provisionerQueryKeys.config(),
    () => shipperFetch<CarrierProvisioningConfiguration>(`/provisioner/config`),
    {
      staleTime: Infinity,
    },
  )
}
